import { render, staticRenderFns } from "./mixed-use-development-in-london.vue?vue&type=template&id=0d3475e7&"
import script from "./mixed-use-development-in-london.vue?vue&type=script&lang=js&"
export * from "./mixed-use-development-in-london.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports